export default __webpack_public_path__ + "static/media/bitmap3.5a7eb2f5.svg";